import api from '@common/api';
import { InvestorAccount, Reward } from '@services/appsync/types';
import { createStore, useStore } from 'zustand';
import { persist } from 'zustand/middleware';

interface RewardsModelProps {
  rewards?: Reward[];
}
interface RewardsModelActions {
  fetchRewards: (investorAccount: InvestorAccount) => Promise<Reward[] | null>;
}

export const RewardsModel = createStore(
  persist<RewardsModelProps & RewardsModelActions>(
    (set) => ({
      fetchRewards: async (investorAccount) => {
        const rewards = await api.allRewards({
          investor_account_id: investorAccount.id,
        });
        if (rewards) set({ rewards });
        return rewards ? rewards : null;
      },
    }),
    {
      getStorage: () => localStorage,
      name: 'rewards-model',
    },
  ),
);

export function useRewardsModel(): RewardsModelProps & RewardsModelActions;
export function useRewardsModel<T>(
  selector: (state: RewardsModelProps & RewardsModelActions) => T,
  equals?: (a: T, b: T) => boolean,
): T;
export function useRewardsModel<T>(
  selector?: (state: RewardsModelProps & RewardsModelActions) => T,
  equals?: (a: T, b: T) => boolean,
) {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return useStore(RewardsModel, selector!, equals);
}
